import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import CustomLink from '../components/CustomLink'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import { SERVICE_VOIP, VOIP_PAYG } from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import VoipUnlimited from '../components/VoipUnlimited'
import VoipPayg from '../components/VoipPayg'

const options = {
    postUrl: '/api/postChangePlanVoip',
    success: 'Success! Your VoIP service has been updated.'
}
const state = {
    serviceId: '',
    planId: '',
    planName: '', // For GA events
    termsOfUse: false,
    termsAndConditions: false
}

class VoipChangePlanForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    componentDidUpdate (prevProps) {
        if (prevProps.plans !== this.props.plans) {
            this.selectPlanIfSingle()
        }
    }

    selectPlanIfSingle () {
        if (this.props.plans.length === 1 && this.props.plans[0]) {
            this.props.setDynamicValues({
                planId: this.props.plans[0].id,
                planName: this.props.plans[0].description
            })
        }
    }

    handleChangePlan (id, planObj) {
        if (this.props.plans[0]) {
            planObj = this.props.plans[0]
            this.props.setDynamicValues({
                planId: id,
                planName: planObj.description
            })
        }
    }

    isUnlimited (monthlyFee) {
        return parseFloat(monthlyFee.replace('$', '')) > 0 && this.props.serviceDetails.includedCalls !== false
    }

    isChangingPlanUnlimited (plan) {
        return parseFloat(plan.monthlyCharge.replace('$', '')) > 0 && plan.includedCalls !== false
    }

    mapExistingPlanFields () {
        return {
            title: this.props.serviceDetails.description,
            price: this.isUnlimited(this.props.serviceDetails.monthlyFee) ? this.props.serviceDetails.monthlyFee : VOIP_PAYG,
            html: this.isUnlimited(this.props.serviceDetails.monthlyFee) ? <VoipUnlimited /> : <VoipPayg />
        }
    }

    mapApiPlanFields () {
        const plans = []
        this.props.plans.forEach(plan => {
            plans.push({
                id: plan.id,
                title: plan.description,
                price: this.isChangingPlanUnlimited(plan) ? plan.monthly_price : VOIP_PAYG,
                html: this.isChangingPlanUnlimited(plan) ? <VoipUnlimited /> : <VoipPayg />
            })
        })

        return plans
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <h2 className='text-center mt-5'>Choose your new Home Phone plan</h2>
                <ComparePlans
                    type={SERVICE_VOIP}
                    plans={this.mapApiPlanFields()}
                    existingPlan={this.mapExistingPlanFields()}
                    handleSelect={this.handleChangePlan.bind(this)}
                    selectedPlanId={parseInt(this.props.values.planId)}
                />
                <div className='row mt-3'>
                    <div className='col-12 text-center'>
                        <CustomLink to='https://files.exetel.com.au/cis/voip/CIS_Home_Phone.pdf'><small>Critical information summary</small></CustomLink>
                    </div>
                </div>
                <div className='mb-3' />
                <TermsOfUseCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsOfUse}
                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                    cisUrl='https://files.exetel.com.au/cis/voip/CIS_Home_Phone.pdf'
                    termsUrl='https://www.exetel.com.au/broadband/nbn/terms'
                />
                <br />
                <TermsAndConditionsCheckbox
                    errors={this.props.errors}
                    value={this.props.values.termsAndConditions}
                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                    type={SERVICE_VOIP}
                />
                <br />

                {this.props.children}

                <div className='row mt-4'>
                    <div className='col-12 col-md-6 text-center text-md-left my-2'>
                        <Button title='Change Plan' action={this.props.handleSubmit} />
                    </div>
                    <div className='col-12 col-md-6 text-center text-md-right my-2'>
                        <input placeholder='Referrer Code' name='referrerCode' value={this.props.values.referrerCode} onChange={this.props.handleInputChange} />
                    </div>
                </div>
            </form>
        )
    }
}

VoipChangePlanForm.propTypes = {
    serviceId: PropTypes.string,
    serviceDetails: PropTypes.object,
    plans: PropTypes.array.isRequired
}

export default FormHOC(VoipChangePlanForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/VoipChangePlanForm.js